export default "__VITE_ASSET__d9a9cb7d__"